module.exports = __webpack_public_path__ + "static/media/college_1.c8cd1e2f.jpg";